import React from "react";
import { ShoppingCart, AlertCircle } from "lucide-react";

const CartAnalyticsWidget = ({ cartData }) => {
  if (!cartData) return null;

  const abandonmentRate = cartData.cartAbandonmentRate || 0;
  const isHighAbandonment = abandonmentRate > 50;

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-pink-500 rounded-md flex items-center justify-center">
            <ShoppingCart className="w-6 h-6 text-white" />
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">Cart Analytics</h3>
            <p className="text-xs text-gray-400">Shopping cart insights</p>
          </div>
        </div>
        {isHighAbandonment && (
          <AlertCircle className="w-5 h-5 text-orange-500" />
        )}
      </div>

      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-xs text-gray-500">Active Carts</p>
            <p className="text-lg font-semibold text-gray-900">
              {cartData.activeCarts || 0}
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Abandoned</p>
            <p className="text-lg font-semibold text-gray-900">
              {cartData.abandonedCarts || 0}
            </p>
          </div>
        </div>

        <div className="border-t pt-4">
          <div className="flex justify-between items-center mb-2">
            <span className="text-xs text-gray-500">Abandonment Rate</span>
            <span
              className={`text-sm font-semibold ${
                isHighAbandonment ? "text-orange-600" : "text-gray-900"
              }`}
            >
              {abandonmentRate.toFixed(1)}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className={`h-2 rounded-full ${
                isHighAbandonment ? "bg-orange-500" : "bg-pink-500"
              }`}
              style={{ width: `${Math.min(abandonmentRate, 100)}%` }}
            ></div>
          </div>
          {isHighAbandonment && (
            <p className="text-xs text-orange-600 mt-1">
              High abandonment rate - consider cart recovery emails
            </p>
          )}
        </div>

        <div className="text-xs text-gray-500 pt-2 border-t">
          <p>Total Carts: {cartData.totalCarts || 0}</p>
        </div>
      </div>
    </div>
  );
};

export default CartAnalyticsWidget;


